import { FILTER_MOUNTED, FILTERS_MOUNTED } from "./const";

/**
 * action
 *
 * @param {string} name filter name
 * @param {boolean} mounted mounted state
 * @returns {Object} redux action object
 */
export function filterMounted(name, mounted) {
  return {
    type: FILTER_MOUNTED,
    name,
    mounted,
  };
}

/**
 * combined filter state action
 *
 * @param {Object} filters
 * @returns {Object} redux action object
 */
export function filtersMounted(filters) {
  return {
    type: FILTERS_MOUNTED,
    filters,
  };
}
